import type { GiftCardFormFields } from '@/modules/cart/domain/Cart';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';

const { GIFTCARD_URL } = environment;

export async function postValidateGiftCard(
  payload: GiftCardFormFields
): Promise<{ data: HttpCartDto }> {
  const response = await httpClient.post(GIFTCARD_URL, payload);
  return Promise.resolve(response);
}
